import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { TagsTemplate } from 'components/Templates'

const Tags: FC = () => {
  return (
    <Layout headline={'お店のオススメポイント'} title={'お店のオススメポイント'}>
      <TagsTemplate />
    </Layout>
  )
}

export default Tags
